var _defs, _rect, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHocBaSo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{fill:#fbdeb1;}.cls-3{fill:#fdbc42;}.cls-4{fill:#ed1869;}.cls-5{fill:#3d55a5;}.cls-6{fill:#18b575;}.cls-7{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "H\\u1ECDc_b\\u1EA1_s\\u1ED1",
    "data-name": "H\\u1ECDc b\\u1EA1 s\\u1ED1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.26,145.73h57.12v33H59.75a7.44,7.44,0,0,1-7.58-7.27V92.82a7.44,7.44,0,0,1,7.58-7.27H84.54v55.37A4.77,4.77,0,0,0,89.26,145.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.83,92.82v37H165.46V85.55h24.79A7.44,7.44,0,0,1,197.83,92.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.83,133.78v37.64a7.44,7.44,0,0,1-7.58,7.27H150.3v-33h10.43a4.77,4.77,0,0,0,4.73-4.81v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 81.74,
    y: 189.65,
    width: 86.58,
    height: 12.31,
    rx: 5.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 88.37,
    y: 48.04,
    width: 73.36,
    height: 94.12,
    rx: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 99.45,
    cy: 56.23,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 111.37,
    cy: 56.23,
    r: 3.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 123.3,
    cy: 56.23,
    r: 3.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.34,
    y: 106.1,
    width: 53.21,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.34,
    y: 117.17,
    width: 59.38,
    height: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.34,
    y: 128.23,
    width: 41,
    height: 3.88
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.34,94H114.5V79.52a13.25,13.25,0,0,1-5,2.91V79a11,11,0,0,0,3.26-1.87,7.07,7.07,0,0,0,2.42-3.19h3.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.55,73.89A5.47,5.47,0,0,1,135.09,76Q137,78.42,137,84.1t-2,8.16a5.46,5.46,0,0,1-4.53,2,5.72,5.72,0,0,1-4.71-2.25q-1.78-2.24-1.79-8t2-8.13A5.46,5.46,0,0,1,130.55,73.89Zm0,3.17a1.88,1.88,0,0,0-1.24.45,2.89,2.89,0,0,0-.85,1.59,22,22,0,0,0-.4,5,21.48,21.48,0,0,0,.36,4.84,3.4,3.4,0,0,0,.89,1.75,2,2,0,0,0,2.48,0,3,3,0,0,0,.84-1.58,21.4,21.4,0,0,0,.4-5,22.19,22.19,0,0,0-.35-4.83,3.43,3.43,0,0,0-.9-1.76A1.87,1.87,0,0,0,130.55,77.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHocBaSo);
export default __webpack_public_path__ + "static/media/hoc_ba_so.6adf3e5d9b358eb640a180af7fec98fd.svg";
export { ForwardRef as ReactComponent };